import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2d9a5ddc"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode(" The page you are trying to access requires authentication. Please sign in or ");

var _hoisted_2 = /*#__PURE__*/_createTextVNode("create an account");

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" to proceed. ");

var _hoisted_4 = {
  class: "content-shape condensed container pt-4"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode("Sign in");

var _hoisted_6 = /*#__PURE__*/_createTextVNode(" Password ");

var _hoisted_7 = {
  class: "recovery-notice"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" Forgot password? ");

var _hoisted_9 = {
  class: "mt-3 pt-2"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" Sign in ");

var _hoisted_11 = /*#__PURE__*/_createTextVNode(" Don’t have an account yet? ");

var _hoisted_12 = /*#__PURE__*/_createTextVNode("Sign up");

import { ref, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import { useUserStore } from "@/store/user";
import { handleError } from "@/utils/errors";
import Link from "@/components/utils/Link.vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var userStore = useUserStore();
    var LoaderState = LoaderStateEnum;
    var loaders = reactive({
      login: LoaderStateEnum.Idle
    });
    var errors = reactive({});
    var model = reactive({
      email: "",
      password: ""
    });
    var rules = {
      email: [{
        required: true,
        trigger: "blur",
        transform: function transform(value) {
          return value.trim();
        }
      }],
      password: [{
        required: true,
        trigger: "blur"
      }]
    };
    var form = ref(null);

    var submit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var next;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (form.value) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return form.value.validate();

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", false);

              case 10:
                loaders.login = LoaderStateEnum.Loading;
                _context.prev = 11;
                _context.next = 14;
                return userStore.login(model);

              case 14:
                next = typeof route.query.to === "string" ? route.query.to : {
                  name: "Home"
                };
                _context.next = 17;
                return router.push(next);

              case 17:
                _context.next = 25;
                break;

              case 19:
                _context.prev = 19;
                _context.t1 = _context["catch"](11);
                _context.next = 23;
                return handleError(_context.t1);

              case 23:
                errors.login = _context.sent;
                loaders.login = LoaderStateEnum.Failed;

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 7], [11, 19]]);
      }));

      return function submit() {
        return _ref.apply(this, arguments);
      };
    }();

    return function (_ctx, _cache) {
      var _component_n_text = _resolveComponent("n-text");

      var _component_n_alert = _resolveComponent("n-alert");

      var _component_n_h1 = _resolveComponent("n-h1");

      var _component_n_input = _resolveComponent("n-input");

      var _component_n_form_item = _resolveComponent("n-form-item");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_form = _resolveComponent("n-form");

      var _component_n_hr = _resolveComponent("n-hr");

      var _component_n_p = _resolveComponent("n-p");

      return _openBlock(), _createElementBlock("div", null, [_unref(route).query.to ? (_openBlock(), _createBlock(_component_n_alert, {
        key: 0,
        type: "info",
        "show-icon": false,
        class: "spotlight text-center rounded-0 unbordered"
      }, {
        default: _withCtx(function () {
          return [_hoisted_1, _createVNode(Link, {
            to: {
              name: 'Signup',
              query: {
                to: _ctx.$route.query.to
              }
            },
            classes: "text-decoration-none"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_text, {
                type: "default",
                underline: ""
              }, {
                default: _withCtx(function () {
                  return [_hoisted_2];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["to"]), _hoisted_3];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(_component_n_h1, null, {
        default: _withCtx(function () {
          return [_hoisted_5];
        }),
        _: 1
      }), _createVNode(_component_n_form, {
        model: _unref(model),
        ref_key: "form",
        ref: form,
        rules: rules
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_form_item, {
            path: "email",
            label: "Email"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_input, {
                value: _unref(model).email,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(model).email = $event;
                }),
                type: "email",
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"]))
              }, null, 8, ["value"])];
            }),
            _: 1
          }), _createVNode(_component_n_form_item, {
            path: "password",
            class: "password-item"
          }, {
            label: _withCtx(function () {
              return [_hoisted_6, _createElementVNode("span", _hoisted_7, [_createVNode(Link, {
                to: {
                  name: 'AccountRecovery',
                  query: {
                    email: _unref(model).email.trim().length > 0 ? _unref(model).email : undefined
                  }
                },
                classes: "text-decoration-none"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_8];
                }),
                _: 1
              }, 8, ["to"])])];
            }),
            default: _withCtx(function () {
              return [_createVNode(_component_n_input, {
                value: _unref(model).password,
                "onUpdate:value": _cache[2] || (_cache[2] = function ($event) {
                  return _unref(model).password = $event;
                }),
                type: "password",
                "show-password-on": "click",
                onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(function () {}, ["prevent"]), ["enter"]))
              }, null, 8, ["value"])];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_9, [_createVNode(_component_n_button, {
            type: "primary",
            size: "large",
            block: true,
            loading: _unref(loaders).login === _unref(LoaderState).Loading,
            onClick: submit
          }, {
            default: _withCtx(function () {
              return [_hoisted_10];
            }),
            _: 1
          }, 8, ["loading"])]), _unref(loaders).login === _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 0,
            type: "error",
            class: "white-space-pre-line mt-3",
            "show-icon": false
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(errors).login), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["model"]), _createVNode(_component_n_hr, {
        class: "my-4"
      }), _createVNode(_component_n_p, null, {
        default: _withCtx(function () {
          return [_hoisted_11, _createVNode(Link, {
            to: {
              name: 'Signup',
              query: {
                to: _ctx.$route.query.to
              }
            },
            classes: "text-decoration-none"
          }, {
            default: _withCtx(function () {
              return [_hoisted_12];
            }),
            _: 1
          }, 8, ["to"])];
        }),
        _: 1
      })])]);
    };
  }
});